import { inputHelper } from '.';

const jwtTokenHelper = {
    objectMapper: () => {
        const obj = {
            Address: '',
            ConcentPolicy: '',
            Cpr: '',
            Email: '',
            FirstName: '',
            Floor: '',
            FullName: '',
            HouseLetter: '',
            HouseNumber: '',
            LastName: '',
            Operation: '',
            PhoneNumber: '',
            SideDoor: '',
            StreetName: ''
        }
    
        if (sessionStorage.getItem('tokenUserData') && sessionStorage.getItem('userData')) {
            const userData = JSON.parse(sessionStorage.getItem('userData'));
            const tokenUserData = JSON.parse(sessionStorage.getItem('tokenUserData'));
    
            userData.Address = userData.Address !== tokenUserData.ADRESSE && userData.Address ? userData.Address : tokenUserData.ADRESSE;
            userData.Cpr = userData.Cpr ? inputHelper.cprNumber.format(userData.Cpr) : null;
            userData.Email = userData.Email !== tokenUserData.MAIL && userData.Email ? userData.Email : tokenUserData.MAIL;
            userData.PhoneNumber = userData.PhoneNumber !== tokenUserData.MOBIL && userData.PhoneNumber ? userData.PhoneNumber : tokenUserData.MOBIL;
            userData.FullName = userData.FullName !== tokenUserData.NAVN && userData.FullName ? userData.FullName : tokenUserData.NAVN;

            return userData;

        } else if (sessionStorage.getItem('tokenUserData')) {
            const tokenUserData = JSON.parse(sessionStorage.getItem('tokenUserData'));
            obj.Address = tokenUserData.ADRESSE;
            obj.Cpr = inputHelper.cprNumber.format(tokenUserData.CPR);
            obj.Email = tokenUserData.MAIL;
            obj.PhoneNumber = tokenUserData.MOBIL;
            obj.FullName = tokenUserData.NAVN;

            return obj;    
        }
    },
    getUserData: (callback) => {
        setTimeout(() => {
            callback(jwtTokenHelper.objectMapper());
        }, 1000);
    }
}

export default jwtTokenHelper;